import { APPOINTMENT_STATUS } from '../../../phan-he-tiep-nhan-thanh-toan/components/tab-tiep-nhan/tab-danh-sach-dat-lich-hen/constants';

export const isValidAppointment = (appointmentItem: any) => {
	return (
		appointmentItem?.id &&
		![
			APPOINTMENT_STATUS.APPOINTMENT_COMPLETED,
			APPOINTMENT_STATUS.APPOINTMENT_CANCELED,
		].includes(appointmentItem?.currStatusCode)
	);
};
